

import * as Configuration from '../../../app.constants.js';

export class SftpExportsService {
  constructor($http, $q) {
    this.$http = $http;
    this.$q = $q;
  }

  getSftpExportsList(companyId) {
    let url = Configuration.constants.baseUrl
            + 'api/1.0/companies/' + companyId
            + '/sftp-exports/';
    return this.$http.get(url);
  }

  createSftpExport(companyId, sftpExport) {
    let url = Configuration.constants.baseUrl
            + 'api/1.0/companies/' + companyId
            + '/sftp-exports/';
    return this.$http.post(url, sftpExport);
  }

  updateSftpExport(companyId, sftpExport) {
    let url = Configuration.constants.baseUrl
            + 'api/1.0/companies/' + companyId
            + '/sftp-exports/' + sftpExport.id;
    return this.$http.put(url, sftpExport);
  }

  deleteSftpExport(companyId, sftpExport) {
    let url = Configuration.constants.baseUrl
            + 'api/1.0/companies/' + companyId
            + '/sftp-exports/' + sftpExport.id;
    return this.$http.delete(url);
  }

  static SftpExportsFactory($http, $q) {
    return new SftpExportsService($http, $q);
  }
}

SftpExportsService.SftpExportsFactory.$inject = ['$http', '$q'];

